import {
  put,
  call,
  select,
  fork,
  takeLatest,
  takeEvery,
  all,
} from 'redux-saga/effects'
import { delay } from 'redux-saga'
import { pick, isUndefined } from 'lodash'
import authSaga from './auth'
import {
  takeLatestAndCancel,
  takeEveryAndCancel,
  takeLatestAndCancelGroupBy,
} from './take'
import { authApiCall } from './helpers'
import makeItemsSaga from './makeItems'
import otherUserSaga from './otherUser'
import swapsSaga from './swaps'
import messagesSaga from './messages'
import fbSaga from './fb'

import {
  notifySuccess,
  // notifyFailure,
  GET_CATEGORIES,
  GET_CATEGORIES_LOADING,
  GET_CATEGORIES_SUCCESS,
  GET_CATEGORIES_FAILURE,
  GET_DISTRICTS,
  GET_DISTRICTS_LOADING,
  GET_DISTRICTS_SUCCESS,
  GET_DISTRICTS_FAILURE,
  GET_ITEMS,
  GET_ITEMS_SEARCH,
  GET_OWNED_ITEMS,
  GET_WANTED_ITEMS,
  GET_INTEREST_ITEMS,
  GET_ITEMS_I_CAN_GET,
  GET_ITEM_DETAIL,
  GET_ITEM_DETAIL_LOADING,
  GET_ITEM_DETAIL_SUCCESS,
  GET_ITEM_DETAIL_FAILURE,
  GET_ITEM_DETAIL_UNLOAD,
  I_WANT,
  I_WANT_LOADING,
  I_WANT_SUCCESS,
  I_WANT_FAILURE,
  I_WANT_NOT,
  I_WANT_NOT_LOADING,
  I_WANT_NOT_SUCCESS,
  I_WANT_NOT_FAILURE,
  LOGOUT,
  AUTH_WITH_TOKEN_SUCCESS,
  LOGIN_SUCCESS,
  REFRESH_LOGGED_USER_COUNTS,
  LOGGED_USER_COUNTS_LOADING,
  LOGGED_USER_COUNTS_FAILURE,
  LOGGED_USER_COUNTS_SUCCESS,
  SET_ITEM_NOT_OWNED,
  SET_ITEM_NOT_OWNED_LOADING,
  SET_ITEM_NOT_OWNED_SUCCESS,
  SET_ITEM_NOT_OWNED_FAILURE,
  CAN_SWAP_ITEM,
  CAN_SWAP_ITEM_LOADING,
  CAN_SWAP_ITEM_FAILURE,
  CAN_SWAP_ITEM_SUCCESS,
  CAN_PROPOSE_SWAP_ITEM,
  CAN_PROPOSE_SWAP_ITEM_LOADING,
  CAN_PROPOSE_SWAP_ITEM_FAILURE,
  CAN_PROPOSE_SWAP_ITEM_SUCCESS,
  GET_ATTRIBUTE_VALUES,
  GET_ATTRIBUTE_VALUES_LOADING,
  GET_ATTRIBUTE_VALUES_SUCCESS,
  GET_ATTRIBUTE_VALUES_FAILURE,
  GET_ATTRIBUTE_VALUES_UNLOAD,
  GET_GENERE_VALUES,
  GET_GENERE_VALUES_LOADING,
  GET_GENERE_VALUES_SUCCESS,
  GET_GENERE_VALUES_FAILURE,
  GET_GENERE_VALUES_UNLOAD,
  ACCEPT_COOKIE,
  DELETE_ACCOUNT,
  DELETE_ACCOUNT_LOADING,
  DELETE_ACCOUNT_SUCCESS,
  DELETE_ACCOUNT_FAILURE,
  REMOVE_INTEREST,
  REMOVE_INTEREST_LOADING,
  REMOVE_INTEREST_SUCCESS,
  REMOVE_INTEREST_FAILURE,
} from '../actions'

import * as api from '../api'

function* handleGetCategories() {
  yield put({ type: GET_CATEGORIES_LOADING })
  try {
    const categories = yield authApiCall(api.getCategories)
    yield put({ type: GET_CATEGORIES_SUCCESS, payload: categories })
  } catch (error) {
    yield put({ type: GET_CATEGORIES_FAILURE, error })
  }
}

function* handleDeleteAccount() {
  yield put({ type: DELETE_ACCOUNT_LOADING })
  try {
    yield authApiCall(api.deleteUser)
    yield put({ type: DELETE_ACCOUNT_SUCCESS })
    yield put({ type: LOGOUT })
  } catch (error) {
    yield put({ type: DELETE_ACCOUNT_FAILURE, error })
  }
}

function* handleGetDistricts() {
  yield put({ type: GET_DISTRICTS_LOADING })
  try {
    const districts = yield authApiCall(api.getDistricts)
    yield put({ type: GET_DISTRICTS_SUCCESS, payload: districts })
  } catch (error) {
    yield put({ type: GET_DISTRICTS_FAILURE, error })
  }
}

function* handleGetItemDetail({ payload: { id, params } }) {
  yield put({ type: GET_ITEM_DETAIL_LOADING })
  try {
    const itemDetail = yield authApiCall(api.getItemDetail, id, params)
    yield put({ type: GET_ITEM_DETAIL_SUCCESS, payload: itemDetail })
  } catch (error) {
    yield put({ type: GET_ITEM_DETAIL_FAILURE, error })
  }
}

function* handleIWant({ payload, successMessage }) {
  const itemId = payload
  yield put({ type: I_WANT_LOADING, payload: itemId })
  try {
    const createdItem = yield authApiCall(api.iWant, itemId)
    if (createdItem) {
      // External item created!
      const meta = { item: createdItem }
      yield put({ type: I_WANT_SUCCESS, payload: itemId, meta })
    } else {
      yield put({ type: I_WANT_SUCCESS, payload: itemId })
    }
    if (successMessage) {
      yield put(notifySuccess({ message: successMessage }))
    }
  } catch (error) {
    if (error.status === 403) {
      yield put({ type: I_WANT_SUCCESS, payload: itemId })
    } else {
      yield put({ type: I_WANT_FAILURE, payload: itemId, error })
    }
  }
}

function* handleIWantNot({ payload, successMessage }) {
  const itemId = payload
  yield put({ type: I_WANT_NOT_LOADING, payload: itemId })
  try {
    yield authApiCall(api.iWantNot, payload)
    yield put({ type: I_WANT_NOT_SUCCESS, payload: itemId })
    if (successMessage) {
      yield put(notifySuccess({ message: successMessage }))
    }
  } catch (error) {
    if (error.status === 404) {
      yield put({ type: I_WANT_NOT_SUCCESS, payload: itemId })
    } else {
      yield put({ type: I_WANT_NOT_FAILURE, payload: itemId, error })
    }
  }
}

function* handleRemoveInterest({ payload }) {
  const itemId = payload
  yield put({ type: REMOVE_INTEREST_LOADING, payload: itemId })
  try {
    yield authApiCall(api.removeInterest, payload)
    yield put({ type: REMOVE_INTEREST_SUCCESS, payload: itemId })
  } catch (error) {
    yield put({ type: REMOVE_INTEREST_FAILURE, payload: itemId, error })
  }
}

function* handleGetLoggedUserCounts({ payload }) {
  yield put({ type: LOGGED_USER_COUNTS_LOADING })
  try {
    const availableCountsCall = {
      ecoins: authApiCall(api.countEcoins),
      itemsICanGet: authApiCall(api.countItemsICanGet),
      newSwaps: authApiCall(api.countNewSwaps),
      wantedItems: authApiCall(api.countWantedItems),
      ownedItems: authApiCall(api.countOwnedItems),
    }
    const countsCall = isUndefined(payload)
      ? availableCountsCall
      : pick(availableCountsCall, payload)
    const counts = yield all(countsCall)

    yield put({
      type: LOGGED_USER_COUNTS_SUCCESS,
      payload: counts,
    })
  } catch (error) {
    yield put({ type: LOGGED_USER_COUNTS_FAILURE, error })
  }
}

function* handleSetItemNotOwned({ payload: { itemId, userId } }) {
  yield put({ type: SET_ITEM_NOT_OWNED_LOADING })
  try {
    yield authApiCall(api.iOwnNot, itemId)
    yield put({ type: SET_ITEM_NOT_OWNED_SUCCESS, payload: { itemId, userId } })
  } catch (error) {
    yield put({ type: SET_ITEM_NOT_OWNED_FAILURE, error })
  }
}

function* handleCanSwapItem({ payload: { itemId } }) {
  yield put({ type: CAN_SWAP_ITEM_LOADING })
  try {
    const numberOfItemsFromItem = yield authApiCall(api.countItemsICanGet, {
      item_id: itemId,
    })
    yield put({
      type: CAN_SWAP_ITEM_SUCCESS,
      payload: numberOfItemsFromItem > 0,
    })
  } catch (error) {
    yield put({ type: CAN_SWAP_ITEM_FAILURE, error })
  }
}

function* handleCanProposeSwapItem({ payload: { itemId, ownerId } }) {
  yield put({ type: CAN_PROPOSE_SWAP_ITEM_LOADING })
  try {
    const numberOfItemsFromOwned = yield authApiCall(api.countItemsICanGet, {
      swapper_id: ownerId,
    })
    yield put({
      type: CAN_PROPOSE_SWAP_ITEM_SUCCESS,
      payload: numberOfItemsFromOwned > 0,
    })
  } catch (error) {
    yield put({ type: CAN_PROPOSE_SWAP_ITEM_FAILURE, error })
  }
}

function* handleAcceptCookie() {
  try {
    yield call([window.localStorage, 'setItem'], 'swapickCookieAccepted', 1)
  } catch (error) {
    console.error("Can't save cookie consent.", error)
  }
}

function* handleGetAttributeValues({
  attribute,
  categoryId,
  q,
  crossFilters,
  posseduto,
  withCount = false,
}) {
  yield put({ type: GET_ATTRIBUTE_VALUES_LOADING, attribute })
  try {
    let values
    if (withCount) {
      values = yield authApiCall(
        api.getAttributeValuesWithCount,
        attribute,
        categoryId,
        q,
        crossFilters,
        posseduto
      )
    } else {
      values = yield authApiCall(api.getAttributeValues, attribute)
    }
    yield put({
      type: GET_ATTRIBUTE_VALUES_SUCCESS,
      payload: values,
      attribute,
    })
  } catch (error) {
    yield put({ type: GET_ATTRIBUTE_VALUES_FAILURE, error, attribute })
  }
}

function* handleGetGenereValues({ payload }) {
  const { categoryId, q, crossFilters, posseduto } = payload
  yield put({ type: GET_GENERE_VALUES_LOADING, payload })
  try {
    const values = yield authApiCall(
      api.getGenereValues,
      categoryId,
      q,
      crossFilters,
      posseduto
    )
    yield put({
      type: GET_GENERE_VALUES_SUCCESS,
      payload: { ...payload, values },
    })
  } catch (error) {
    yield put({ type: GET_GENERE_VALUES_FAILURE, error, payload })
  }
}

// Polling refresh counts
function* refreshCounts() {
  while (true) {
    yield call(delay, 60 * 1000)
    const user = yield select(state => state.auth.user)
    if (user) {
      yield put({ type: REFRESH_LOGGED_USER_COUNTS })
    }
  }
}

const filterNoOwnedItems = items => items.filter(item => item.posseduto_da)

// TODO: Split this spaghetti!
export default function* rootSaga() {
  // Global common stuff
  yield takeLatest(GET_CATEGORIES, handleGetCategories)
  yield takeLatest(GET_DISTRICTS, handleGetDistricts)
  // Auth
  yield fork(
    authSaga({
      login: credentials => {
        if (credentials.fb) {
          return api.loginFacebook(credentials)
        } else {
          return api.login(credentials)
        }
      },
      me: api.me,
    })
  )
  // Delete account
  yield takeEvery(DELETE_ACCOUNT, handleDeleteAccount)
  // This means: Ok we have the user logged both from login or from inital auth \w token =)
  yield takeEvery([AUTH_WITH_TOKEN_SUCCESS, LOGIN_SUCCESS], function*() {
    yield put({ type: REFRESH_LOGGED_USER_COUNTS })
  })
  yield fork(
    takeEveryAndCancel,
    [REFRESH_LOGGED_USER_COUNTS],
    LOGOUT,
    handleGetLoggedUserCounts
  )
  yield fork(refreshCounts)
  // Items
  yield fork(
    makeItemsSaga(
      GET_ITEMS,
      api.getItems,
      state => state.allItems,
      filterNoOwnedItems
    )
  )
  // Search Items
  yield fork(
    makeItemsSaga(GET_ITEMS_SEARCH, api.getItems, state => state.searchItems)
  )
  yield fork(
    makeItemsSaga(GET_OWNED_ITEMS, api.getOwnedItems, state => state.ownedItems)
  )
  yield fork(
    makeItemsSaga(
      GET_WANTED_ITEMS,
      api.getWantedItems,
      state => state.wantedItems
    )
  )
  yield fork(
    makeItemsSaga(
      GET_INTEREST_ITEMS,
      api.getInterestItems,
      state => state.interestItems
    )
  )
  yield fork(
    makeItemsSaga(
      GET_ITEMS_I_CAN_GET,
      api.getItemsICanGet,
      state => state.itemsICanGet,
      filterNoOwnedItems
    )
  )
  yield fork(
    takeLatestAndCancel,
    GET_ITEM_DETAIL,
    GET_ITEM_DETAIL_UNLOAD,
    handleGetItemDetail
  )
  yield fork(
    takeLatestAndCancel,
    CAN_SWAP_ITEM,
    GET_ITEM_DETAIL_UNLOAD,
    handleCanSwapItem
  )
  yield fork(
    takeLatestAndCancel,
    CAN_PROPOSE_SWAP_ITEM,
    GET_ITEM_DETAIL_UNLOAD,
    handleCanProposeSwapItem
  )
  yield takeEvery(I_WANT, handleIWant)
  yield takeEvery(I_WANT_NOT, handleIWantNot)
  yield takeEvery(REMOVE_INTEREST, handleRemoveInterest)
  yield takeEvery(SET_ITEM_NOT_OWNED, handleSetItemNotOwned)
  // Swaps
  yield fork(swapsSaga)
  // Messages
  yield fork(messagesSaga)
  // Other user
  yield fork(otherUserSaga)
  // Fuck Mark
  yield fork(fbSaga)
  // Attributes values
  yield fork(
    takeLatestAndCancelGroupBy,
    GET_ATTRIBUTE_VALUES,
    GET_ATTRIBUTE_VALUES_UNLOAD,
    ({ attribute }) => attribute,
    handleGetAttributeValues
  )
  // Genere values
  yield fork(
    takeLatestAndCancelGroupBy,
    GET_GENERE_VALUES,
    GET_GENERE_VALUES_UNLOAD,
    ({ payload }) => payload.categoryId,
    handleGetGenereValues
  )
  // Store cookie accepted
  yield takeEvery(ACCEPT_COOKIE, handleAcceptCookie)
}



// WEBPACK FOOTER //
// ./src/saga/index.js